import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';

export const GetAccessToBranch = createAsyncThunk(
  'branchAccess/GetAccessToBranch',
  async (userId, { rejectWithValue }) => {
    try {
      const res = await api.get(`auth/get-branch/${userId}`);   // users -> auth
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch' });
    }
  }
);